import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  add: {
    marginLeft: '10px',
  },
}));
